(function () {
  const STORAGE_KEY = 'a11y-preferences';
  const TEXT_LEVELS = [1, 1.15, 1.3, 1.5];
  const OPTIONS = ['contrast', 'links', 'font', 'spacing', 'motion'];

  const widget = document.getElementById('A11yWidget');
  if (!widget) return;

  const toggle = widget.querySelector('.a11y-widget__toggle');
  const panel = widget.querySelector('.a11y-widget__panel');
  const closeButton = widget.querySelector('.a11y-widget__close');
  const textLevelOutput = widget.querySelector('.a11y-widget__text-level');
  const root = document.documentElement;

  let prefs = load();

  function load() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) {}
  }

  function setVideosPaused(paused) {
    document.querySelectorAll('video').forEach((video) => {
      if (video.closest('.a11y-widget')) return;
      if (paused && !video.paused) {
        video.dataset.a11yPaused = 'true';
        video.pause();
      } else if (!paused && video.dataset.a11yPaused) {
        delete video.dataset.a11yPaused;
        video.play().catch(() => {});
      }
    });
  }

  function apply() {
    const level = Math.min(Math.max(prefs.text || 0, 0), TEXT_LEVELS.length - 1);
    root.classList.toggle('a11y-text', level > 0);
    root.style.setProperty('--a11y-text-scale', TEXT_LEVELS[level]);
    textLevelOutput.textContent = `${Math.round(TEXT_LEVELS[level] * 100)}%`;

    OPTIONS.forEach((option) => {
      const enabled = Boolean(prefs[option]);
      root.classList.toggle(`a11y-${option}`, enabled);
      const button = widget.querySelector(`[data-a11y-option="${option}"]`);
      if (button) button.setAttribute('aria-pressed', String(enabled));
    });

    setVideosPaused(Boolean(prefs.motion));
  }

  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    closeButton.focus();
  }

  function closePanel(returnFocus) {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) toggle.focus();
  }

  toggle.addEventListener('click', () => {
    panel.hidden ? openPanel() : closePanel(false);
  });

  closeButton.addEventListener('click', () => closePanel(true));

  widget.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) closePanel(true);
  });

  document.addEventListener('click', (event) => {
    if (!panel.hidden && !widget.contains(event.target)) closePanel(false);
  });

  widget.querySelectorAll('[data-a11y-text]').forEach((button) => {
    button.addEventListener('click', () => {
      const step = Number(button.dataset.a11yText);
      prefs.text = Math.min(Math.max((prefs.text || 0) + step, 0), TEXT_LEVELS.length - 1);
      save();
      apply();
    });
  });

  widget.querySelectorAll('[data-a11y-option]').forEach((button) => {
    button.addEventListener('click', () => {
      const option = button.dataset.a11yOption;
      prefs[option] = !prefs[option];
      save();
      apply();
    });
  });

  widget.querySelector('.a11y-widget__reset').addEventListener('click', () => {
    prefs = {};
    save();
    apply();
  });

  apply();
})();
